import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

interface DataCarouselProps {
  currentIndex: number;
  totalRows: number;
  onGoToRow: (index: number) => void;
  onNext: () => void;
  onPrev: () => void;
}

export const DataCarousel: React.FC<DataCarouselProps> = ({
  currentIndex,
  totalRows,
  onGoToRow,
  onNext,
  onPrev,
}) => {
  if (totalRows === 0) return null;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1 && value <= totalRows) {
      onGoToRow(value - 1);
    }
  };

  return (
    <div className="flex items-center gap-2 bg-card p-2 rounded-lg border border-border">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => onGoToRow(0)}
        disabled={currentIndex === 0}
      >
        <ChevronsLeft className="w-4 h-4" />
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={onPrev}
        disabled={currentIndex === 0}
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>

      <div className="flex items-center gap-1 text-sm">
        <Input
          type="number"
          min={1}
          max={totalRows}
          value={currentIndex + 1}
          onChange={handleInputChange}
          className="w-14 h-8 text-center"
        />
        <span className="text-muted-foreground">of {totalRows}</span>
      </div>

      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={onNext}
        disabled={currentIndex === totalRows - 1}
      >
        <ChevronRight className="w-4 h-4" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => onGoToRow(totalRows - 1)}
        disabled={currentIndex === totalRows - 1}
      >
        <ChevronsRight className="w-4 h-4" />
      </Button>
    </div>
  );
};
